export default "__VITE_ASSET__DKBOFy1w__"